module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/video/video.component.css
// module id = ./src/app/video/video.component.css
// module chunks = main